<template>
  <a-collapse v-bind="attrs" :class="bem.b()">
    <template
      v-for="item in Object.keys($slots).filter(
        (slot) => slot !== 'expandIcon'
      )"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <template v-if="$slots.expandIcon || props.expandIcon" #expandIcon="data">
      <slot v-if="$slots.expandIcon" name="expandIcon" v-bind="data" />
      <ll-icon
        v-else
        :style="{
          transform: data.isActive ? 'rotate(90deg)' : 'rotate(0deg)',
          transition: 'all 0.3s ease',
        }"
        :icon-name="props.expandIcon"
      />
    </template>
  </a-collapse>
</template>

<script lang="ts" setup>
import { useAttrs } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import { collapseProps } from './collapse'

defineOptions({ name: 'LlCollapse' })
const bem = createNamespace('collapse')
const attrs = useAttrs()

const props = defineProps(collapseProps)
</script>
